import { NestedFormComponent } from '../../../../contexts/NestedFormControlContext/NestedFormComponent';
import { PatientCommonCardComponent } from '../../../patient/component/PatientCardComponent/PatientCommonCardComponent';
import {
  WorklistBasicInformationFormContainer,
  WorklistBasicInformationFormContainerProps,
} from '../../container/WorklistBasicInformationFormContainer/WorklistBasicInformationFormContainer';
import { WorklistInsuranceFormContainer } from '../../container/WorklistBasicInformationFormContainer/WorklistInsuranceFormContainer';

export interface WorklistBasicInformationComponentProps
  extends WorklistBasicInformationFormContainerProps {
  onSubmitInsurance?: () => void;
  }

export const WorklistBasicInformationComponent = ({
  patientId,
  patientInfoService,
  onSubmit,
  onSubmitInsurance,
}: WorklistBasicInformationComponentProps) => (
  <PatientCommonCardComponent
    title="Basic Information"
    updateInfo={patientInfoService.updateInfo}
    content={(<div />)}
    formContent={(
      <>
        <NestedFormComponent>
          <WorklistBasicInformationFormContainer
            patientId={patientId}
            patientInfoService={patientInfoService}
            onSubmit={onSubmit}
          />
        </NestedFormComponent>
        <WorklistInsuranceFormContainer
          patientInfoService={patientInfoService}
          onSubmit={onSubmitInsurance}
        />
      </>
    )}
    showEdit={false}
    isEditing
  />
);
